/**
 * .p-button-icon-only has bo background, borders, box-shadows.
 * .p-button-icon-only.btn-icon it's normal icon only button with borders, background, etc
 * .p-button normal button.
 */

export const buttonConfig = {
  colorScheme: {
    light: {
      paddingX: "14px",
      paddingY: "var(--spacing-8)",
      sm: {
        paddingX: "11px",
        paddingY: "7px",
      },
      primary: {
        background: "var(--p-primary-600)",
        hoverBackground: "var(--p-primary-700)",
      },
      secondary: {
        background: "white",
        hoverBackground: "var(--p-gray-50)",
      },
      text: {
        primary: {
          hover: {
            background: "white",
          },
        },
      },
    },
  },
  borderRadius: "var(--spacing-8)",
  gap: "var(--spacing-4)",
  extend: {
    icon: {
      only: {
        padding: "10px",
      },
    },
  },
  css: ({ dt }: any) => `
  p-button {
    display: flex;
    width: 100%;
    .p-button {
      width: 100%;
      height: fit-content !important;
    }
  }
    .p-button:disabled {
      color: var(--p-gray-400);
      cursor: not-allowed;
    }

    .p-button-primary:disabled, .p-button-secondary:disabled {
      border: 2px solid var(--p-gray-200);
      box-shadow: var(--shadow-xs);
    }

    .p-button-primary:disabled {
      background-color: var(--p-gray-100);
    }
    .p-button-secondary:disabled {
      background-color: white;
    }

    .p-button:not(.p-button-icon-only:not(.btn-icon)) {
      &.p-button-primary:not(:disabled), &.p-button-secondary:not(:disabled){
        box-shadow: var(--shadow-xs-skeuomorphic);
        font: var(--font-text-sm-semi-bold);
      }
      &.p-button-secondary:not(:disabled), &.p-button-secondary:not(:disabled):hover{
        &:has(.btn-icon) {
         border: 1px solid var(--p-gray-300);
        }
      }

      &.p-button:not(.btn-icon):not(:disabled) {
        border: 2px solid;
        border-image-source: var(--gradient-skeuemorphic-gradient-border);
      }
    }

    .p-button-icon-only {
      width: auto;
      padding: ${dt("button.icon.only.padding")};
      border-radius: var(--radius-8);
    }

    .p-button-icon-only:not(.btn-icon):not(.p-splitbutton-dropdown) {
      background-color: transparent;
    }
    .p-button-icon-only:not(.btn-icon):not(.p-splitbutton-dropdown):not(.p-dialog-close-button) {
      &.p-button-secondary {
        box-shadow: none;
        border: none;
      }
      &.p-button-secondary:hover {
        background-color: var(--p-gray-50);
        border: none;
      }
      &:focus {
        background-color: white;
        box-shadow: 0px 0px 0px 4px #9E77ED, 0px 0px 0px 2px #FFFFFF;
      }
    }
  `,
};
